// extracted by mini-css-extract-plugin
export default {"name":"customPlanRow__name-ZKQxn","column":"customPlanRow__column-wZdjR","menu":"customPlanRow__menu-VSREa"};